const SectionApp = () => (
  <section id="app" className="py-16 md:py-20 bg-background-100">
    <div className="max-w-[1280px] mx-auto px-4 md:px-6">
      <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 max-w-[1000px] mx-auto">
        <div className="flex-shrink-0 w-56 md:w-64">
          <img
            src="https://readdy.ai/api/search-image?query=Mobile%20app%20interface%20mockup%20showing%20entertainment%20news%20feed%20with%20trending%20topics%2C%20warm%20red%20and%20gold%20color%20scheme%2C%20clean%20modern%20UI%20design%2C%20social%20media%20style%20layout%2C%20no%20text%2C%20app%20store%20preview%20mockup&width=512&height=512&seq=app-qr-2026&orientation=squarish"
            alt="吃瓜网每日大赛移动端入口"
            className="w-full h-auto rounded-2xl object-cover"
            loading="lazy"
          />
        </div>
        <div className="flex-1 text-center lg:text-left">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">随时随地，轻松吃瓜</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
            吃瓜网每日大赛已适配移动端访问，无论您使用手机还是平板，都能享受流畅的吃瓜体验。收藏本站，不再错过任何一个大瓜。
          </p>
          <div className="mt-6 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
            <span className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-primary-500 text-background-50 font-semibold text-sm whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors">
              <i className="ri-smartphone-line"></i>
              手机端访问
            </span>
            <span className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg border-2 border-primary-200 text-primary-700 font-semibold text-sm whitespace-nowrap cursor-pointer hover:bg-primary-50 transition-colors">
              <i className="ri-bookmark-line"></i>
              收藏本站地址
            </span>
          </div>
          <p className="mt-4 text-xs text-foreground-400">最新入口地址将实时更新，确保安全直达</p>
        </div>
      </div>
    </div>
  </section>
);

export default SectionApp;